import React from "react";
import { View, StyleSheet, Text } from "react-native";
import { WorkspaceHeader } from "../../components/chatNewInterface/interfaceComponents/workspaceHeader/WorkspaceHeader";

interface ChatEmptyStateProps {
  title: string;
  input: React.ReactNode;
}

const ChatEmptyState = ({ title, input }: ChatEmptyStateProps) => {
  return (
    <View style={styles.container}>
      <WorkspaceHeader title={title} />
      <View style={styles.content}>
        <View style={styles.emptyStateArea}>
          <View style={styles.emptyStateContent}>
            <Text style={styles.emptyStateTitle}>How can I help you today?</Text>
            {input}
          </View>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
  },
  content: {
    flex: 1,
    display: "flex",
    flexDirection: "row",
    overflow: "hidden",
  },
  emptyStateArea: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#f9fafbb3",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  emptyStateContent: {
    width: "100%",
    maxWidth: 770,
    paddingHorizontal: 20,
    paddingTop: 60,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 24,
  },
  emptyStateTitle: {
    fontSize: 32,
    fontWeight: "600",
    color: "#1f2937",
    textAlign: "center",
  },
});

export default ChatEmptyState;
